import React, { useState, FormEvent } from "react";
import {
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Link,
  Paper,
} from "@material-ui/core";
import { Link as RouterLink, useHistory } from "react-router-dom";
import Footer from "./../components/Footer";
import ReCAPTCHA from "react-google-recaptcha";
import Axios from "axios";
import {
  AUTH_API,
  AUTH_AXIOS_OPTIONS,
  AXIOS_OPTIONS,
  MAIN_API,
} from "../utils/constants";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const Login = () => {
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [recaptcha, setRecaptcha] = useState("");
  // const [captchaIsValid, setCaptchaIsValid] = useState(false);
  const [wrongPassword, setWrongPassword] = useState(false);
  const history = useHistory();

  const login = async (e: FormEvent) => {
    e.preventDefault();

    if (loginData.username.trim() === "" || loginData.password.trim() === "") {
      alert("Todos los campos son obligatorios");
      return;
    }

    try {
      // Recaptcha validation
      const recaptchaResponse = await Axios.post(
        `${MAIN_API}/validate-recaptcha`,
        {
          response: recaptcha,
        },
        AXIOS_OPTIONS
      );
      if (!recaptchaResponse.data.success) {
        return Swal.fire(
          "Error de reCAPTCHA",
          "La prueba de reCAPTCHA no fue superada",
          "error"
        );
      }

      // Ends recaptcha validation

      const api = await Axios.post(
        `${AUTH_API}/usuarios/login`,
        loginData,
        AUTH_AXIOS_OPTIONS
      );
      if (api.status === 204) return setWrongPassword(true);

      const data = api.data;
      localStorage.setItem("jwt", data.token);
      localStorage.setItem("permisos", JSON.stringify(data.permisos));
      history.push("/");
      window.location.reload();
    } catch (err) {
      const error = err as any;
      const res = error.response;
      if (res.status && res.status === 400)
        return toast.error("Usuario o contraseña no válidos");
      toast.error(`${error}`);
    }
  };

  return (
    <section style={{ backgroundColor: "#BFBFBF", minHeight: "100vh" }}>
      <Container
        style={{ backgroundColor: "white", padding: 0, overflow: "hidden" }}
      >
        <div
          style={{
            backgroundColor: "#DFDFDF",
            padding: 15,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <a
            style={{ color: "#939393", marginRight: 15 }}
            href="https://www.tabasco.gob.mx"
          >
            tabasco.gob.mx
          </a>
          <a
            style={{ color: "#939393" }}
            href="https://www.tabasco.gob.mx/isset"
          >
            Portal ISSET
          </a>
        </div>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <div style={{ padding: 15 }}>
              <img
                src={require("./../assets/images/isset-logo.png")}
                alt="ISSET Logo"
                style={{ width: 150 }}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div
              style={{
                padding: 15,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={require("./../assets/images/infoisset-logo.png")}
                alt="InfoISSET Logo"
              />
            </div>
          </Grid>
        </Grid>
        <Grid style={{ marginTop: 15, padding: 10 }} container spacing={3}>
          <Grid item md={2}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                src={require("./../assets/images/icono-trabajador.png")}
                alt="Trabajador ISSET"
              />
            </div>
          </Grid>
          <Grid item md={6}>
            <Typography component="h2" variant="h5">
              Estimado usuario:
            </Typography>
            <Typography component="p" variant="body1" style={{ marginTop: 15 }}>
              A través de este portal puedes imprimir tu sobre de pago,
              consultar tus datos personales y tu historial laboral.
              <br />
              <br />
              Para obtener acceso a este servicio en línea, deberás conocer tu
              Número de Cuenta y responder unas preguntas que nos permitirán
              verificar tu identidad.
              <br />
              <br />
              Para activar tu cuenta, haz clic{" "}
              <Link component={RouterLink} to="/signin">
                aquí
              </Link>
              .<br />
              <br />
              {/* // TODO: Crear el formulario de registro */}
              Para cualquier aclaración, favor de comunicarte al Departamento de
              Recursos Humanos, al teléfono{" "}
              <Link href="tel:9933582850">(993) 358 2850</Link> Extensión 63073.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper style={{ backgroundColor: "#DFDFDF", padding: 10 }}>
              <Typography variant="body2">
                Ingresa al Portal de Servicios en Línea InfoISSET, con tu número
                de afiliación y contraseña.
              </Typography>
              <form style={{ marginTop: 15 }} onSubmit={login}>
                <TextField
                  label="Nombre de usuario"
                  fullWidth
                  variant="outlined"
                  value={loginData.username}
                  onChange={(e) =>
                    setLoginData({ ...loginData, username: e.target.value })
                  }
                />
                <TextField
                  label="Contraseña"
                  fullWidth
                  variant="outlined"
                  type="password"
                  style={{ marginTop: 15 }}
                  value={loginData.password}
                  onChange={(e) =>
                    setLoginData({ ...loginData, password: e.target.value })
                  }
                />
                <div
                  style={{
                    marginTop: 15,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
                    onChange={(value) => {
                      if (value) setRecaptcha(value);
                    }}
                    onExpired={() => setRecaptcha("")}
                  />
                </div>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={
                    !recaptcha || !loginData.username || !loginData.password
                  }
                  color="primary"
                  style={{ width: "100%", marginTop: 15 }}
                >
                  Ingresar
                </Button>
                {wrongPassword ? (
                  <Typography style={{ textAlign: "center" }} color="error">
                    Los datos proporcionados son incorrectos
                  </Typography>
                ) : null}
                {/* <div style={{textAlign: "center", marginTop: 15}}>
                                    <Link component={RouterLink} to="/password-recovery" style={{textAlign: "center"}}>Haz click aquí si olvidaste tu contraseña.</Link>
                                </div> */}
              </form>
            </Paper>
            <div style={{ textAlign: "center", marginTop: 15 }}>
              <Typography variant="body2">
                ¿Eres trabajador afiliado al ISSET y todavía no cuentas con
                acceso al Portal de Servicios en Línea? <br />
                <Link component={RouterLink} to="/signin">
                  Obtén acceso al portal haciendo clic aquí
                </Link>
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid>
          <Footer />
        </Grid>
      </Container>
    </section>
  );
};

export default Login;
